import { file, filePdf, filePng } from '../file/file.fixture';
import { TemporaryFile } from './temporary-file.model';

export const temporaryFilePdf: TemporaryFile = {
    originalFile: filePdf,
    originalFileName: filePdf.name,
    uuid: '1',
    type: filePdf.type,
};

export const temporaryFilePng: TemporaryFile = {
    originalFile: filePng,
    originalFileName: filePng.name,
    uuid: '1',
    type: filePng.type,
};

export const temporaryFile: TemporaryFile = {
    originalFile: file,
    originalFileName: file.name,
    uuid: '3',
    type: file.type,
};
